import React from 'react';
import PropTypes from 'prop-types';

const OwnerCard = ({ name, addresses, emails, phones }) => {
  return (
    <div className="card border-0">
      <div className="card-header py-2 border-bottom text-muted small bg-light">
        {name}
      </div>
      <div className="card-body p-0">
        <div className="row m-0 py-2 border-bottom text-muted small">
          <div className="col">Addresses</div>
          <div className="col text-end d-flex flex-column gap-2">
            <span>{addresses[0]}</span>
            <span>{addresses[1]}</span>
          </div>
        </div>
        <div className="row m-0 py-2 border-bottom text-muted small">
          <div className="col">Email</div>
          <div className="col text-end d-flex flex-column gap-2">
            <a className="text-decoration-underline" href="javascript:;">
              {emails[0]}
            </a>
            <a className="text-decoration-underline" href="javascript:;">
              {emails[1]}
            </a>
          </div>
        </div>
        <div className="row m-0 py-2 text-muted small">
          <div className="col">Phone</div>
          <div className="col text-end d-flex flex-column gap-2">
            <a className="text-decoration-underline" href="javascript:;">
              {phones[0]}
            </a>
            <a className="text-decoration-underline" href="javascript:;">
              {phones[1]}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

const ownerData = [
  {
    name: 'John Doe',
    addresses: ['123 Main St, Springfield, IL', '456 Elm St, Springfield, IL'],
    emails: ['johndoe@example.com', 'doejohn@example.com'],
    phones: ['+15554325678', '+15554325679'],
  },
  {
    name: 'Jane Smith',
    addresses: ['789 Oak St, Springfield, IL', '101 Pine St, Springfield, IL'],
    emails: ['janesmith@example.com', 'smithjane@example.com'],
    phones: ['+15554325680', '+15554325681'],
  },
];

const llcData = {
  name: 'XYZ LLC',
  addresses: ['987 Maple St, Springfield, IL', '654 Birch St, Springfield, IL'],
  emails: ['contact@xyzllc.com', 'support@xyzllc.com'],
  phones: ['+15554325682', '+15554325683'],
};

export default function FakeContacts() {
  return (
    <div className="d-none d-md-flex flex-column gap-2">
      <div>
        <h6>Owner Info</h6>
        <div className="d-flex flex-column gap-2 border rounded">
          {ownerData.map((owner, index) => (
            <OwnerCard
              addresses={owner.addresses}
              emails={owner.emails}
              key={index}
              name={owner.name}
              phones={owner.phones}
            />
          ))}
        </div>
      </div>
      <div>
        <h6>LLC Information</h6>
        <OwnerCard
          addresses={llcData.addresses}
          emails={llcData.emails}
          name={llcData.name}
          phones={llcData.phones}
        />
      </div>
    </div>
  );
}

OwnerCard.propTypes = {
  addresses: PropTypes.array.isRequired,
  emails: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  phones: PropTypes.array.isRequired,
};
